import { NgModule } from '@angular/core';

import { TTDateFormatPipe, TTBoolFormatPipe, TTDateAgoPipe, TTDateFormatPipe2 } from './global.pipe';

@NgModule({
    imports :[
    ],
    exports:[
        TTDateFormatPipe,
        TTBoolFormatPipe,
        TTDateAgoPipe,
        TTDateFormatPipe2
    ],
    declarations: [
        TTDateFormatPipe,
        TTBoolFormatPipe,
        TTDateAgoPipe,
        TTDateFormatPipe2
    ],
    providers:[
        TTDateFormatPipe,
        TTBoolFormatPipe,
        TTDateAgoPipe,
        TTDateFormatPipe2
    ]
})

export class GlobalPipesModule{}